export default function hashId() {
	const array = new Uint32Array(2);
	const crypto = window.crypto || window.msCrypto;
	crypto.getRandomValues(array);

	return array[0].toString(36) + array[1].toString(36);
}
